"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var router_1 = require("@angular/router");
var service_service_1 = require("src/app/Services/service.service");
var search_results_component_1 = require("src/app/Adv/search-results/search-results.component");
var moment = require("moment");
var WickedApiClient_1 = require("../../api/WickedApiClient");
var advertisement_service_1 = require("../../Services/advertisement.service");
var environment_1 = require("src/environments/environment");
var AdvUserAdvertisementsComponent = /** @class */ (function () {
    function AdvUserAdvertisementsComponent(route, service) {
        var _this = this;
        this.route = route;
        this.service = service;
        this.advLoading = true;
        this.pageSizeOptions = [5, 10, 25, 100];
        this.listLayoutType = search_results_component_1.displayModeType;
        this._listLayout = search_results_component_1.displayModeType.LIST;
        this._viewMode = advertisement_service_1.ViewMode.ALL;
        this.service.advService.searchInActionChanged.subscribe(function (s) {
            _this.advLoading = s;
        });
    }
    AdvUserAdvertisementsComponent.prototype.ngOnInit = function () {
        if (!this.service.userService.isDemo()) {
            this.viewMode = advertisement_service_1.ViewMode.ACTIVE;
        }
        this.service.advService.searchDataUserAdv.currentSearchRule.pageNumber = 0;
        this.performSearch();
    };
    AdvUserAdvertisementsComponent.prototype.performSearch = function () {
        this.currentUserId = this.service.userService.getUserId();
        this.service.advService.searchDataUserAdv.currentSearchRule.userId = this.currentUserId;
        this.service.advService.searchActionForUser(this.viewMode);
    };
    Object.defineProperty(AdvUserAdvertisementsComponent.prototype, "currentUserId", {
        get: function () {
            return this._currentUserId;
        },
        set: function (value) {
            this._currentUserId = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AdvUserAdvertisementsComponent.prototype, "length", {
        get: function () {
            return this.service.advService.searchDataUserAdv.resultCount;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AdvUserAdvertisementsComponent.prototype, "pageSize", {
        get: function () {
            return this.service.advService.searchDataUserAdv.currentSearchRule.pageSize;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AdvUserAdvertisementsComponent.prototype, "pageNumber", {
        get: function () {
            return this.service.advService.searchDataUserAdv.currentSearchRule.pageNumber;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AdvUserAdvertisementsComponent.prototype, "pageEvent", {
        get: function () {
            return this._pageEvent;
        },
        set: function (value) {
            this.service.advService.searchDataUserAdv.currentSearchRule.pageNumber = value.pageIndex;
            this.service.advService.searchDataUserAdv.currentSearchRule.pageSize = value.pageSize;
            this.service.advService.searchActionForUser(this.viewMode);
            this._pageEvent = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AdvUserAdvertisementsComponent.prototype, "listLayout", {
        get: function () {
            return this._listLayout;
        },
        set: function (value) {
            this._listLayout = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AdvUserAdvertisementsComponent.prototype, "viewMode", {
        get: function () {
            return this._viewMode;
        },
        set: function (value) {
            this._viewMode = value;
        },
        enumerable: true,
        configurable: true
    });
    AdvUserAdvertisementsComponent.prototype.advIsExpired = function (adv) {
        return adv.dateStart.isSameOrBefore(moment().subtract(14, 'day'));
    };
    Object.defineProperty(AdvUserAdvertisementsComponent.prototype, "cardList", {
        get: function () {
            return this.service.advService.searchDataUserAdv.resultList;
        },
        enumerable: true,
        configurable: true
    });
    // public getLocation(id:number)
    // {
    //   if(this.service.advService.getRegionNameById(id))
    //   {
    //      return this.service.advService.getRegionNameById(id).name;
    //   }
    //   else
    //   {
    //     return "";
    //   }
    // }
    AdvUserAdvertisementsComponent.prototype.getPremiumText = function (advertisement) {
        if (advertisement.showAs == WickedApiClient_1.ShowAdType.PremiumAd) {
            return "Premium Ad";
        }
        else if (advertisement.showAs == WickedApiClient_1.ShowAdType.PremiumUser) {
            return "Premium User";
        }
        else if (advertisement.isPremium) {
            if (advertisement.isPremiumUser) {
                return "Premium User";
            }
            else {
                return "Premium Ad";
            }
        }
        return "";
    };
    AdvUserAdvertisementsComponent.prototype.getImageFromCard = function (card) {
        if (card.images.length > 0) {
            var mainImage = card.images.filter(function (v) { return v.isMain == true; });
            if (mainImage.length > 0) {
                return environment_1.environment.apiBaseUrl + "/FileGet/" + mainImage[0].fileName;
            }
            else {
                return environment_1.environment.apiBaseUrl + "/FileGet/" + card.images[0].fileName;
            }
        }
        else {
            return "";
        }
    };
    AdvUserAdvertisementsComponent.prototype.openAdv = function (id) {
        this.service.route.navigate(["adv-edit/" + id]);
    };
    AdvUserAdvertisementsComponent.prototype.viewModeIsActive = function () {
        return this.viewMode == advertisement_service_1.ViewMode.ACTIVE;
    };
    AdvUserAdvertisementsComponent.prototype.viewModeIsExpired = function () {
        return this.viewMode == advertisement_service_1.ViewMode.EXPIRED;
    };
    AdvUserAdvertisementsComponent.prototype.setViewMode = function (newMode) {
        if (newMode == 'ACTIVE') {
            this.viewMode = advertisement_service_1.ViewMode.ACTIVE;
        }
        else if (newMode == 'EXPIRED') {
            this.viewMode = advertisement_service_1.ViewMode.EXPIRED;
        }
        else
            this.viewMode = advertisement_service_1.ViewMode.ALL;
        this.service.advService.searchDataUserAdv.currentSearchRule.pageNumber = 0;
        this.performSearch();
    };
    AdvUserAdvertisementsComponent.prototype.repostAdv = function (adv) {
        //this.service.advService.repost(adv.advertisementId).then(res => {
        //  this.service.showInformation('Your ad was reposted for next 14 days');
        //  adv.dateStart = moment()
        //}).catch(err => {
        //  this.service.showError(err);
        //})
    };
    return AdvUserAdvertisementsComponent;
}());
exports.AdvUserAdvertisementsComponent = AdvUserAdvertisementsComponent;
